import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class ConfirmDialogModel {

    constructor(public title: string,
        public message: string,
        public cancelLocalizationKey?: string,
        public confirmLocalizationKey?: string,
        public isOkMode: boolean = false) {
    }
}

@Component({
    selector: 'odq-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

    isOkMode = false;
    title: string;
    message: string;
    cancelLocalizationKey = 'navigation.cancel';
    confirmLocalizationKey = 'navigation.ok';

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {

    }

    ngOnInit() {
        this.title = this.data.title;
        this.message = this.data.message;
        this.cancelLocalizationKey = this.data?.cancelLocalizationKey || this.cancelLocalizationKey;
        this.confirmLocalizationKey = this.data?.confirmLocalizationKey || this.confirmLocalizationKey;
        this.isOkMode = this.data.isOkMode;
    }

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}
